import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import SectionHeading from "../Chip/SectionHeading";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../utils/colors";
import { BORDER_RADIUS } from "../../utils/constants";

const CardContainer = ({
  title,
  children,
  onClick,
  sx,
  sxContainer,
  dynamicHeight = false,
  hasError = false,
  aiGeneratedSection,
}) => {
  const sxDynamicHeight = dynamicHeight
    ? { maxHeight: "100%" }
    : { height: "100%" };

  const errorStyles = hasError
    ? {
        border: `1px solid #ef4444`,
        boxShadow: "0 1px 2px 0 rgba(239, 68, 68, 0.05)",
      }
    : {};

  return (
    <Card
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "fields.background",
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        boxShadow: BOX_SHADOW_THEME,
        borderRadius: BORDER_RADIUS,
        p: 1,
        ...sxDynamicHeight,
        ...errorStyles,
        ...sxContainer,
        overflow: "visible",
      }}
    >
      <CardHeader
        onClick={onClick}
        sx={{
          pb: 0,
          ...sx,
        }}
        title={
          aiGeneratedSection?.basePath && aiGeneratedSection?.section ? (
            <SectionHeading
              basePath={aiGeneratedSection.basePath}
              section={aiGeneratedSection.section}
            >
              {title}
            </SectionHeading>
          ) : (
            title
          )
        }
      />
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {children}
      </CardContent>
    </Card>
  );
};

export default CardContainer;
